import { useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Server } from '@wajeez-web/core/api-base';
import {
  SystemConfigsActions,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { SuperAdminSystemPermissions } from '@wajeez-web/core/types';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

import { SystemConfigModal } from '../components/SystemConfigModal';

export const SystemConfigsPage = () => {
  const [isSystemConfigModalOpen, setIsSystemConfigModalOpen] = useState(false);
  const [selectedSystemConfig, setSelectedSystemConfig] =
    useState<Partial<Server.UpdateSystemConfigInput>>();

  const dataTable = useContentSelector(
    ({ systemConfigs }) => systemConfigs.dataTable
  );

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData(
      'systemConfigs',
      SystemConfigsActions.getSystemConfigsDataTableAsync
    );

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`System Configs`}
        withoutRightPadding={false}
        breadCrumbsLinks={[{ title: 'System Configs' }]}
      >
        <DataTableWrapper
          data={dataTable.data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={dataTable.status === 'loading'}
          rowActions={(row) => {
            return [
              {
                title: 'Edit',
                permission: SuperAdminSystemPermissions.systemConfigs.edit,
                endpoint: '',
                type: 'request',
                action: () => {
                  setIsSystemConfigModalOpen(true);
                  setSelectedSystemConfig({ id: Number(row[1]) });
                },
              },
            ];
          }}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </PageLayoutsContainer>
      {isSystemConfigModalOpen && selectedSystemConfig?.id && (
        <SystemConfigModal
          isOpen={isSystemConfigModalOpen}
          onClose={() => {
            setIsSystemConfigModalOpen(false);
            setSelectedSystemConfig(undefined);
          }}
          id={selectedSystemConfig?.id}
          onSubmit={() => {
            setIsSystemConfigModalOpen(false);
            setSelectedSystemConfig(undefined);

            tablePreferances && setTablePreferences({ ...tablePreferances });
          }}
        />
      )}
    </div>
  );
};
